<template>
    <div class="product-review-guest-modal">
        <h2>{{ messages.modalTitle }}</h2>

        <div class="product-review-guest">
            <div class="product-review-guest__block" v-html="description"></div>
            <div class="product-review-guest__block">
                {{ messages.leaveReviewInfo }}
                <DefLink :href="authHref">
                    {{ messages.auth.text }}
                </DefLink>
            </div>
        </div>

    </div>
</template>

<script>
    import DefLink from "../../../Def/DefLink/DefLink.vue";

    export default {
        name: "ProductReviewGuestModal",
      components: {DefLink},
        selector: ".product-review-guest-modal",
        props: ['messages', 'description', 'review'],

        methods: {
            closeModal() {
                this.$emit("close");
            },
        },
        computed: {
            /**
             * механика для подкидывания ID отзыва (или общей кнопки (Оставить отзыв) для редиректа после авторизации (backurl)
             * @returns {string}
             */
            authHref() {
                let {url, backURL} = this.messages.auth;
                let reviewID = this.review.ID ?? 'N';
                if (backURL) {
                    url += '?backurl=';
                    let splitBackURL = backURL.split('?');
                    if (splitBackURL.length === 1) {
                        url += splitBackURL[0] + encodeURIComponent(`?reviewID=${reviewID}`);
                    } else if (splitBackURL.length === 2) {
                        let encodeBackURL = '';
                        encodeBackURL += splitBackURL.map((el, ind) => {
                            if (ind === 1) {
                                const searchParams = new URLSearchParams('?' + el);
                                searchParams.set('reviewID', reviewID);
                                return searchParams.toString();
                            }
                            return el;
                        }).join('?');
                        url += encodeURIComponent(encodeBackURL);
                    }
                }
                return url;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .product-review-guest-modal {
        h2 {
            padding: 30px 0 0 50px;
            margin-bottom: 20px;
        }

        &__close {
            cursor: pointer;
            position: absolute;
            top: 8px;
            right: 8px;
            z-index: 1;

            svg {
                fill: #85898B;
                width: 20px;
                height: 20px;
            }
        }
    }

    .product-review-guest {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        gap: 15px;
        padding: 0 50px 50px 50px;
        font-size: rem(12);

        &__block {
            width: 100%;

            :deep(.def-link) {
                color: #faa295;
            }
        }

        @include point-lg {
            flex-direction: row;
            gap: 80px;
        }
    }
</style>